module.exports = __WEBPACK_EXTERNAL_MODULE_27__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/checkbox/dist/mdc.checkbox","commonjs2":"@material/checkbox/dist/mdc.checkbox","commonjs":"@material/checkbox/dist/mdc.checkbox","amd":"@material/checkbox/dist/mdc.checkbox","umd":"@material/checkbox/dist/mdc.checkbox"}
// module id = 27
// module chunks = 0